import React from 'react';

const RubyLogo = (props) => (
    <svg preserveAspectRatio="xMidYMid" viewBox="0 0 256 255" {...props}>
        <defs>
            <linearGradient
                id="ruby-prefix__i"
                x1="-20.7%"
                x2="104.2%"
                y1="122.3%"
                y2="-6.3%"
            >
                <stop offset="0%" stopColor="#BD0012" />
                <stop offset="0%" stopColor="#BD0012" />
                <stop offset="7%" stopColor="#FFF" />
                <stop offset="17%" stopColor="#FFF" />
                <stop offset="27%" stopColor="#C82F1C" />
                <stop offset="33%" stopColor="#820C01" />
                <stop offset="46%" stopColor="#A31601" />
                <stop offset="72%" stopColor="#B31301" />
                <stop offset="99%" stopColor="#E82609" />
                <stop offset="100%" stopColor="#E82609" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__a"
                x1="84.8%"
                x2="58.3%"
                y1="111.4%"
                y2="64.6%"
            >
                <stop offset="0%" stopColor="#FB7655" />
                <stop offset="0%" stopColor="#FB7655" />
                <stop offset="41%" stopColor="#E42B1E" />
                <stop offset="99%" stopColor="#900" />
                <stop offset="100%" stopColor="#900" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__c"
                x1="75.8%"
                x2="39%"
                y1="219.3%"
                y2="7.8%"
            >
                <stop offset="0%" stopColor="#871101" />
                <stop offset="0%" stopColor="#871101" />
                <stop offset="99%" stopColor="#911209" />
                <stop offset="100%" stopColor="#911209" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__d"
                x1="50%"
                x2="66.5%"
                y1="7.2%"
                y2="79.1%"
            >
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="23%" stopColor="#E57252" />
                <stop offset="46%" stopColor="#DE3B20" />
                <stop offset="99%" stopColor="#A60003" />
                <stop offset="100%" stopColor="#A60003" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__e"
                x1="46.2%"
                x2="49.9%"
                y1="16.3%"
                y2="83%"
            >
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="23%" stopColor="#E4714E" />
                <stop offset="56%" stopColor="#BE1A0D" />
                <stop offset="99%" stopColor="#A80D00" />
                <stop offset="100%" stopColor="#A80D00" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__f"
                x1="37%"
                x2="49.5%"
                y1="15.6%"
                y2="92.5%"
            >
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="18%" stopColor="#E46342" />
                <stop offset="40%" stopColor="#C82410" />
                <stop offset="99%" stopColor="#A80D00" />
                <stop offset="100%" stopColor="#A80D00" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__g"
                x1="13.6%"
                x2="85.8%"
                y1="58.3%"
                y2="-46.7%"
            >
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="54%" stopColor="#C81F11" />
                <stop offset="99%" stopColor="#BF0905" />
                <stop offset="100%" stopColor="#BF0905" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__h"
                x1="27.6%"
                x2="50.7%"
                y1="21.1%"
                y2="79.1%"
            >
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="31%" stopColor="#DE4024" />
                <stop offset="99%" stopColor="#BF190B" />
                <stop offset="100%" stopColor="#BF190B" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__b"
                x1="116.7%"
                x2="1.7%"
                y1="60.9%"
                y2="19.3%"
            >
                <stop offset="0%" stopColor="#871101" />
                <stop offset="0%" stopColor="#871101" />
                <stop offset="99%" stopColor="#911209" />
                <stop offset="100%" stopColor="#911209" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__j"
                x1="58.8%"
                x2="12%"
                y1="65.2%"
                y2="50.1%"
            >
                <stop offset="0%" stopColor="#8C0C01" />
                <stop offset="0%" stopColor="#8C0C01" />
                <stop offset="54%" stopColor="#990C00" />
                <stop offset="99%" stopColor="#A80D0E" />
                <stop offset="100%" stopColor="#A80D0E" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__k"
                x1="79.3%"
                x2="23.1%"
                y1="62.8%"
                y2="17.9%"
            >
                <stop offset="0%" stopColor="#7E110B" />
                <stop offset="0%" stopColor="#7E110B" />
                <stop offset="99%" stopColor="#9E0C00" />
                <stop offset="100%" stopColor="#9E0C00" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__l"
                x1="92.9%"
                x2="59.8%"
                y1="74.1%"
                y2="39.7%"
            >
                <stop offset="0%" stopColor="#79130D" />
                <stop offset="0%" stopColor="#79130D" />
                <stop offset="99%" stopColor="#9E120B" />
                <stop offset="100%" stopColor="#9E120B" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__o"
                x1="56.6%"
                x2="3.1%"
                y1="101.7%"
                y2="12%"
            >
                <stop offset="0%" stopColor="#8B2114" />
                <stop offset="0%" stopColor="#8B2114" />
                <stop offset="43%" stopColor="#9E100A" />
                <stop offset="99%" stopColor="#B3100C" />
                <stop offset="100%" stopColor="#B3100C" />
            </linearGradient>
            <linearGradient
                id="ruby-prefix__p"
                x1="30.9%"
                x2="92.5%"
                y1="35.6%"
                y2="100.7%"
            >
                <stop offset="0%" stopColor="#B31000" />
                <stop offset="0%" stopColor="#B31000" />
                <stop offset="44%" stopColor="#910F08" />
                <stop offset="99%" stopColor="#791C12" />
                <stop offset="100%" stopColor="#791C12" />
            </linearGradient>
            <radialGradient
                id="ruby-prefix__m"
                cx="32%"
                cy="40.2%"
                r="69.6%"
                fx="32%"
                fy="40.2%"
            >
                <stop offset="0%" stopColor="#A80D00" />
                <stop offset="0%" stopColor="#A80D00" />
                <stop offset="99%" stopColor="#7E0E08" />
                <stop offset="100%" stopColor="#7E0E08" />
            </radialGradient>
            <radialGradient
                id="ruby-prefix__n"
                cx="13.5%"
                cy="40.9%"
                r="88.4%"
                fx="13.5%"
                fy="40.9%"
            >
                <stop offset="0%" stopColor="#A30C00" />
                <stop offset="0%" stopColor="#A30C00" />
                <stop offset="99%" stopColor="#800E08" />
                <stop offset="100%" stopColor="#800E08" />
            </radialGradient>
        </defs>
        <path
            fill="url(#ruby-prefix__a)"
            d="M197 168L52 254l188-13 15-190-58 117z"
        />
        <path fill="url(#ruby-prefix__b)" d="M241 241l-17-112-44 59 61 53z" />
        <path fill="url(#ruby-prefix__c)" d="M241 241l-119-9-69 22 188-13z" />
        <path fill="url(#ruby-prefix__d)" d="M53 254l29-97-65 14 36 83z" />
        <path fill="url(#ruby-prefix__e)" d="M180 188L153 81l-78 73 105 34z" />
        <path fill="url(#ruby-prefix__f)" d="M249 83l-74-61-21 67 95-6z" />
        <path fill="url(#ruby-prefix__g)" d="M214 1l-43 24-28-24h71z" />
        <path fill="url(#ruby-prefix__h)" d="M0 203l18-33-15-39-3 72z" />
        <path
            fill="#FFF"
            d="M2 129l15 42 65-14 73-68 21-66-33-23-55 21-53 49-33 59z"
        />
        <path
            fill="url(#ruby-prefix__i)"
            d="M54 54c38-37 87-60 106-41s-1 65-39 103c-38 37-86 61-105 42s1-66 38-104z"
        />
        <path
            fill="url(#ruby-prefix__j)"
            d="M53 254l29-97 98 31c-35 33-75 61-127 66z"
        />
        <path
            fill="url(#ruby-prefix__k)"
            d="M155 89l25 99c30-31 56-64 69-106l-94 7z"
        />
        <path
            fill="url(#ruby-prefix__l)"
            d="M249 83c10-30 12-74-35-82l-39 21 74 61z"
        />
        <path fill="#9E1209" d="M0 203c1 50 37 51 53 51l-36-83-17 32z" />
        <path
            fill="url(#ruby-prefix__m)"
            d="M155 89l70 42c1 1 19-31 23-48l-93 6z"
        />
        <path
            fill="url(#ruby-prefix__n)"
            d="M82 157l39 75c24-12 42-28 59-44l-98-31z"
        />
        <path
            fill="url(#ruby-prefix__o)"
            d="M17 171l-5 67c10 14 25 15 40 14-11-27-33-82-35-81z"
        />
        <path
            fill="url(#ruby-prefix__p)"
            d="M175 23l78 11c-4-18-17-29-39-33l-39 22z"
        />
    </svg>
);

export default RubyLogo;
